import '@/styled-system/styles/recipes/units-module.css';
import { unitsModule } from '@/styled-system/recipes';

export const {
  contentStack,
  floorPlanImageOuter,
  floorPlanImageWrapper,
  floorPlanImage,
  floorPlanImageButton,
  noFloorPlanPlaceholder,
  placeholderText,
  placeholderSubtext,
  floorPlanSummary,
  floorPlanSummaryRow,
  floorPlanSummarySeparator,
  floorPlanFeesBadge,
  totalMonthlyPriceNotice,
  cardContent,
  unitTableResponsive,
  unitTable,
  unitNameColumn,
  unitRentColumn,
  unitDetailsColumn,
  unitTableHeader,
  unitTableHeaderAvailable,
  unitTableHeaderChevron,
  unitTableRow,
  cellWithBadgeArea,
  badgeArea,
  unitNameCell,
  unitNameButton,
  unitNameText,
  rentCellContent,
  rentValue,
  rentText,
  priceDropOriginal,
  priceDropArrow,
  placeholderValue,
  availableCell,
  chevronCell,
  chevronChar,
  seeAllLink,
  seeAllArrow,
  mobileCarouselItem,
  desktopCarouselItem,
  carouselContainer,
  desktopCarouselContainer,
  desktopCarouselRow,
  desktopArrowColumn,
  desktopCardsArea,
  desktopControlButton,
  baseCard,
  compactCard,
  compactImageWrapper,
  compactUnitTableWrapper,
  bedroomTab,
  dotContainer,
  floorPlanDots,
  floorPlanDot,
  modalBackdrop,
  modalContent,
  modalHeader,
  modalTitle,
  modalTitleDetail,
  modalCloseButton,
  modalBody,
  modalImageColumn,
  modalTableColumn,
  sortContainer,
  sortTrigger,
  sortLabel,
  sortValue,
  sortChevron,
  sortDropdownPanel,
  sortOption,
  sortOptionSelected,
  sheetImageBorder,
  sheetImagePadding,
  sheetPlaceholderInner,
  sheetPlaceholderText,
  sheetPlaceholderSubtext,
  seeAllUnitsImage,
  headerTitleDetail,
} = unitsModule();
